var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{class:{ 'fixed bottom-0 left-0 right-0 z-1 ph3 bg-white custom-shadow flex flex-column justify-center': _vm.fixed }},[_vm._t("default")],2)}
var staticRenderFns = []

export { render, staticRenderFns }